import { render, staticRenderFns } from "./Last20TransactionList.vue?vue&type=template&id=4cd9b42c&lang=pug"
import script from "./Last20TransactionList.vue?vue&type=script&lang=js"
export * from "./Last20TransactionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports